module.exports = __webpack_public_path__ + "img/198.24139f22.jpg";